const runtimeApiUrl =
  window.__ENV__?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

const browserDefaultApiUrl =
  typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.hostname}:8000`
    : "http://localhost:8000";

export const API_URL = runtimeApiUrl || browserDefaultApiUrl;

// Auth is an httpOnly cookie, so every API call must opt in to sending it.
// Same-origin would send it anyway in production, but local development runs
// the SPA on :3000 and the API on :8000, where it would otherwise be dropped.
export function apiFetch(path, options = {}) {
  return fetch(`${API_URL}${path}`, { credentials: "include", ...options });
}
